import React from 'react';
import { SparkModalPortal, ModalFeedback, Text } from '@spark';

export const DeleteProjectModal = ({
    visible,
    onCancel,
    onConfirm,
    projectName,
    loading = false,
    isFilteredDelete = false,
    filteredTaskCount,
}) => {
    const handleCancel = () => {
        if (loading) return;
        onCancel();
    };

    const taskCount = filteredTaskCount ?? 0;
    const taskNoun = taskCount === 1 ? 'task' : 'tasks';

    return (
        <SparkModalPortal
            open={visible}
            onClose={handleCancel}
            destroyOnClose
            size="text"
            keyboard={!loading}
        >
            <ModalFeedback
                feedbackType="warning"
                title={isFilteredDelete ? 'Delete filtered tasks?' : 'Delete project?'}
                content={
                    isFilteredDelete ? (
                        <>
                            Are you sure you want to delete the {taskCount} {taskNoun} matching
                            your current filters in{' '}
                            <Text variant="base-semibold" as="strong">
                                {projectName}
                            </Text>
                            ? This permanently removes those tasks and everything associated with
                            them, including data and evaluations. Other tasks in this project will
                            not be deleted.
                        </>
                    ) : (
                        <>
                            Are you sure you want to delete{' '}
                            <Text variant="base-semibold" as="strong">
                                {projectName}
                            </Text>
                            ? This permanently removes the project and everything associated with it, including tasks, data, and evaluations.
                        </>
                    )
                }
                showClose
                showOverlay={false}
                danger
                primaryLabel={isFilteredDelete ? 'Delete Tasks' : 'Delete Project'}
                tertiaryLabel="Cancel"
                primaryDisabled={loading}
                primaryDisableWhenReadOnly
                onCloseClick={handleCancel}
                onPrimaryClick={onConfirm}
                onTertiaryClick={handleCancel}
            />
        </SparkModalPortal>
    );
};
